import http from "./httpService";
import config from "../config.json";

const apiEndpoint = config.apiEndpoint + "/stats";

export async function getStats(userId, leagueId, seasonId) {
  const response = await http.get(
    apiEndpoint + "/" + userId + "/" + leagueId + "/" + seasonId
  );
  return response.data;
}



// WEBPACK FOOTER //
// ./src/services/statsService.js